import { render, staticRenderFns } from "./SuggestedItemDepartments.vue?vue&type=template&id=37f9b15c"
import script from "./SuggestedItemDepartments.vue?vue&type=script&lang=js"
export * from "./SuggestedItemDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports